import React from 'react';
import { ReactComponent as HiddenEye } from '../../assets/images/icons/hiddenEye.svg';

export default function HiddenEyeIcon(props) {
  return (
    <HiddenEye className={`icon ${props.className}`} />
  );
}
